import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { GenericEntryForm } from '../../../infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { ExchangeRateModel, IExchangeRateModel, IExchangeRateModelSAP } from 'src/app/core/models/masters/exchangerate-master.model';
import { MatDialog } from '@angular/material/dialog';
import { UpdateExchangeRateComponent } from '../update-exchange-rate/update-exchange-rate.component';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { enumFormModes } from 'src/app/infrastructure/infrastructure-services/common/common-enums';
import { forkJoin } from 'rxjs';
import { GlobalProperties } from 'src/app/global/global-properties';
import { WrapperStandardFilter, WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { SecurityService } from 'src/app/login-layout/Service/security.service';

@Component({
  selector: 'app-exchangerateentry-form',
  templateUrl: './exchangerate-entryform.component.html',
  styleUrls: []
})
export class ExchangeRateEntryFormComponent extends GenericEntryForm<IExchangeRateModel, IExchangeRateModelSAP> {


  //displayedColumns: any[] = [];
  displayedColumns: string[] = [];

  lstMonth: any[] = [];
  testArr: any[] = [];
  reqArray: any[] = [];
  lstYear: any[] = [];
  lstData: any[] = [];
  test1: any[] = [];
  test2: any[] = [];
  currencyData: any[] = [];
  test: any[] = [];
  lstFilterData: any[] = [];
  lstFilteredData :any [] =[];
  lstCurrencyRate: any[] = [];
  setDisplayedColumnsNamesList: any = [];
  fromDialog!: string
  @ViewChild('dialogRef')
  dialogRef!: TemplateRef<any>
  displayedColumnsForRate: string[];
  FromDate: any;
  ToDate: any;
  itemRequest: any
  _URL: any
  fromDate: any;
  toDate: any;
  rate: any;
  currency: any;
  reqDate: any;
  originalData: Array<any> = new Array();
  forkObj: any = new Object();
  isPressed: boolean = false;
  selectedDate =1;

  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;
  isActiveMenu: boolean = true;

  checkMenuPermissions() {
    let securityService = new SecurityService();
    let permissions: any = securityService.getMenuPermissions(this.getFormSubTitle);

    this.canAdd = permissions.canAdd === true || permissions.canAdd === 'true';
    this.canEdit = permissions.canEdit === true || permissions.canEdit === 'true';
    this.canView = permissions.canView === true || permissions.canView === 'true';
    this.isActiveMenu = permissions.isActive === true || permissions.isActive === 'true';
  }

  constructor(agenericRepository: GenericService<IExchangeRateModel>,
    private activatedRoute: ActivatedRoute, router: Router, dialog: MatDialog, public routerForCfl: Router, private http: HttpClient) {
    super(agenericRepository, router, dialog);

    this.setMenuCode = "M311";
    this.setFormSubTitle = "Exchange Rate Master";
    this.checkMenuPermissions();

    this.setListViewFormRouteTo = "/dashboardEntryform";
    //this.setRequestDataForFormModeNew = "";

    //this.setURLForFormModeEdit = "ExchangeRatesAndIndexes/GetExchangeRatesAndIndexesService";
    this.setURLForFormModeAddSap = "SBOBobService_SetCurrencyRate";
    this.setURLForFormModeUpdateSap = `SBOBobService_SetCurrencyRate`;

    this.displayedColumns = [];
    this.lstMonth = [
      { id: 1, name: 'January' },
      { id: 2, name: 'February' },
      { id: 3, name: 'March' },
      { id: 4, name: 'April' },
      { id: 5, name: 'May' },
      { id: 6, name: 'June' },
      { id: 7, name: 'July' },
      { id: 8, name: 'August' },
      { id: 9, name: 'September' },
      { id: 10, name: 'October' },
      { id: 11, name: 'November' },
      { id: 12, name: 'December' }
    ];

    for (let index = 2001; index <= 2050; index++) {
      this.lstYear.push({ id: index, name: index });
    }
    let exrate = new ExchangeRateModel();

    let myDate = new Date();
    exrate.currentMonth = myDate.getMonth() + 1;
    exrate.currentYear = myDate.getFullYear();
    this.displayedColumnsForRate = ['Check', 'Currency', 'Rate'];
    this.setEntryFormDataSource = exrate;
   
    exrate.code = this.activatedRoute.snapshot.params['id'];
    this.getFilterDataAccToMonthYear(this.getEntryFormDataSource.currentMonth, this.getEntryFormDataSource.currentYear);
    if (exrate.code > 0) {
      this.setRequestDataForFormModeEdit = exrate.code;
      this.setFormMode = enumFormModes.ModeEdit;
    }
    else {
      this.setFormMode = enumFormModes.ModeNew;
    }
    this.PopulateEntryForm();
  }
  ngOnInit() {

  }

  onValidate(): boolean {

    let lreturn: boolean = true;

    return lreturn
  }


  onChangeCurrency(val?: any, currency?: any, date?: any): void {

    let _length = this.testArr.filter(x => x.date == date && x.currency == currency).length;
    if (_length > 0) {
      this.testArr.filter(x => x.date == date && x.currency == currency)[0].rate = val;
    }
    else {
      this.testArr.push({ 'date': date, 'rate': val, 'currency': currency });
    }

  }

  PatchAPIForSAP(aUrl: string, aRequestData: any): any {
    this.http.patch(aUrl, aRequestData, { withCredentials: true }).
      subscribe((res: any) => {
        if (this.btnText == 'Language.UpdateText') {
          this.btnText = 'Language.OkText';
          return res;
        }
      })
  }

  getFilterDataAccToMonthYear(_Month: any, _Year: any) {
    let _index = 0;
    if (_Month == 2 && _Year % 4 == 0) {
      _index = 29;
    }
    else if (_Month == 2 && _Year % 4 > 0) {
      _index = 28;
    }
    else if (_Month == 4 || _Month == 6 || _Month == 9 || _Month == 11) {
      _index = 30;
    }
    else {
      _index = 31;
    }
    let fromDateFormat: string;
    let toDateFormat: string;
    if (_Month == 11 || _Month == 12 || _Month == 10) {
      fromDateFormat = _Year + "-" + _Month + "-0" + "1";
      toDateFormat = _Year + "-" + _Month + "-" + _index;
    }
    else {
      fromDateFormat = _Year + "-0" + _Month + "-0" + "1";
      toDateFormat = _Year + "-0" + _Month + "-" + _index;
    }

    this.fromDate = fromDateFormat;
    this.toDate = toDateFormat;
    this.getListApi(_index, _Month, _Year);
    this.getCurrencyData();
  }

  onChangeMonthAndYear(aEvent: any) {

    this.lstFilterData = [];
    this.lstFilteredData=[];
    this.lstData=[];
    this.getFilterDataAccToMonthYear(this.getEntryFormDataSource.currentMonth, this.getEntryFormDataSource.currentYear);
   
  }

  lstDates: number[] = [];

 
  
  

  openDialog1(): void {


    let displayColumns = [...this.displayedColumns]; // New reference
    displayColumns.splice(displayColumns.indexOf("Date"), 1);
  
    let filterDialogRef = this.dialog.open(UpdateExchangeRateComponent, {

      data: {
        FromDate: this.fromDate,
        ToDate: this.toDate,
        displayCol: displayColumns,
        updateColData: [],

      }
    });
    filterDialogRef.afterClosed().subscribe((res: any) => {
      if (res != undefined && res.event != undefined) {
        if (res.data != null && res.data != '') {
          this.isPressed = true;
        }
        console.log(res)
        this.updateTableData(res);
      }
    });
  }
  updateTableData(val: any) {
    var pipe = new DatePipe('en-US');
    val.endDate = pipe.transform(val.endDate, 'yyyy-MM-dd');
    this.getDatesInRange(new Date(val.startDate), new Date(val.endDate), val);
  }

  getDatesInRange(startDate: any, endDate: any, val: any) {
    const date = new Date(startDate.getTime());
    let dates: any = [];
    while (date <= endDate) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      const formattedDate = `${day}-${month}-${year}`;

      dates.push(formattedDate);
      date.setDate(date.getDate() + 1);
    }

    for (const ele of this.lstData) {
      for (let i = 0; i <= dates.length; i++) {
        if (ele.Date == dates[i]) {
          for (const el of val.data) {

            if (el.column) {
              ele[el.column] = el.value;
              this.onChangeCurrency(el.value, el.column, ele.Date);
            }
          }
        }
      }

    }
    return dates;
  }

  getListApi(_index: any, _Month: any, _Year: any) {
    this.lstData = [];
     this.itemRequest=new WrapperStandardRequest();
    // this.itemRequest = {

    //   "UserGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "UserId": "0",
    //   "CompanyCode": "SBODEMOIN",
    //   "PageRecordCount": 50,
    //   "PageSize": 1,
    //   "IsAcending": true,
    //   "SortColumn": "code"

    // };
    this.itemRequest.PageRecordCount=31;
    this.itemRequest.SortColumn="rateDate";
    // this.itemRequest = {
    //   "userId": 0,
    //   "userGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "companyCode": "SBODEMOIN",
    //   "pageRecordCount": 100,
    //   "pageSize": 1,
    //   "isAcending": true,
    //   "sortColumn": "rateDate",

    //   "requestData": [
    //     {
    //       "Key": "rateDate",
    //       "Value": `${this.fromDate}`,
    //       "OperatorType": ">="
    //     },
    //     {
    //       "Key": "rateDate",
    //       "Value": `${this.toDate}`,
    //       "OperatorType": "<="
    //     }
    //   ]
    // };


    let filter1 = new WrapperStandardFilter();
    filter1.Key="rateDate";
    filter1.Value= `${this.fromDate}`;
    filter1.OperatorType=">=";
    let filter2 = new WrapperStandardFilter();
    filter2.Key="rateDate";
    filter2.Value= `${this.toDate}`;
    filter2.OperatorType="<=";
    this.itemRequest.RequestData=[filter1,filter2];
    this._URL = `${GlobalProperties.getApiUrl}ExchangeRatesAndIndexes/GetExchangeRatesAndIndexesListService`;
    this.http.post(this._URL, this.itemRequest, { withCredentials: true }).
      subscribe(
     {  next: (res: any) => {
        this.lstData = [];
        this.lstData = res.responseData;

        this.lstFilterData = [];
        this.lstFilteredData =[];
        let obj = {
          Date: "",
          exchangeValue: "",
        };
        var val;
        var pipe = new DatePipe('en-US');
        // res.responseData.forEach((element: any, index: number) => {
        //   var obj1 = {
        //     Date: pipe.transform(element.rateDate, 'dd-MM-yyyy'),
        //     //isDisabled: true
        //   }
        //   obj.Date = element.rateDate,
        //     obj.exchangeValue = element.exchangeRatesAndIndexesResponseListDtos
        //   element.exchangeRatesAndIndexesResponseListDtos.forEach((ele: any, i: number) => {
        //     val = ele.currency;
        //     var obj2 = {
        //       [val]: ele.rate,

        //     }
        //     obj1 = Object.assign(obj1, obj2)
        //   });
        //   this.lstFilterData.push(obj1);
        // });
        // this.lstData = this.lstFilterData;
       
const allDates: any[] = [];
const apiDates: any = []; // Stores existing API dates

// Get current month and year
const year = this.getEntryFormDataSource.currentYear;
const month = this.getEntryFormDataSource.currentMonth;

// Get number of days in the selected month
const daysInMonth = new Date(year, month, 0).getDate();

// Step 1: Generate all dates for the selected month
for (let day = 1; day <= daysInMonth; day++) {
  const formattedDate = pipe.transform(new Date(year, month - 1, day), 'dd-MM-yyyy');
  allDates.push({ Date: formattedDate, exchangeValue: {} }); // Empty row for missing dates
}

// Step 2: Process API Data
  res.responseData.forEach((element: any, index: number) => {
          var obj1 = {
            Date: pipe.transform(element.rateDate, 'dd-MM-yyyy'),
            //isDisabled: true
          }
          obj.Date = element.rateDate,
            obj.exchangeValue = element.exchangeRatesAndIndexesResponseListDtos
          element.exchangeRatesAndIndexesResponseListDtos.forEach((ele: any, i: number) => {
            val = ele.currency;
            var obj2 = {
              [val]: ele.rate,

            }
            obj1 = Object.assign(obj1, obj2)
          });
          this.lstFilteredData.push(obj1);
        });
        this.lstFilterData = this.lstFilteredData;

// Step 3: Merge API Data with Empty Dates
this.lstData = allDates.map(dateObj => {
  const existingData = this.lstFilterData.find(d => d.Date === dateObj.Date);
  return existingData ? existingData : dateObj; // Use API data if available, otherwise keep empty row
});
        this.originalData = JSON.parse(JSON.stringify(this.lstData));
      },
      error:(err:any)=>{

 this.lstData = [];
     

        this.lstFilterData = [];
        this.lstFilteredData =[];
        let obj = {
          Date: "",
          exchangeValue: "",
        };
        var val;
        var pipe = new DatePipe('en-US');

        const allDates: any[] = [];
const apiDates: any = []; // Stores existing API dates

// Get current month and year
const year = this.getEntryFormDataSource.currentYear;
const month = this.getEntryFormDataSource.currentMonth;

// Get number of days in the selected month
const daysInMonth = new Date(year, month, 0).getDate();

// Step 1: Generate all dates for the selected month
for (let day = 1; day <= daysInMonth; day++) {
  const formattedDate = pipe.transform(new Date(year, month - 1, day), 'dd-MM-yyyy');
  allDates.push({ Date: formattedDate, exchangeValue: {} }); // Empty row for missing dates
}
  this.lstFilterData = this.lstFilteredData;

// Step 3: Merge API Data with Empty Dates
this.lstData = allDates.map(dateObj => {
  const existingData = this.lstFilterData.find(d => d.Date === dateObj.Date);
  return existingData ? existingData : dateObj; // Use API data if available, otherwise keep empty row
});
    this.originalData = JSON.parse(JSON.stringify(this.lstData));

      }
      
   
    }
    );
  }

  getCurrencyData() {

    this.itemRequest=new WrapperStandardRequest();
    // this.itemRequest = {

    //   "UserGuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    //   "UserId": "0",
    //   "CompanyCode": "SBODEMOIN",
    //   "PageRecordCount": 50,
    //   "PageSize": 1,
    //   "IsAcending": true,
    //   "SortColumn": "code"

    // };
    this.itemRequest.SortColumn="code";
    this._URL = `${GlobalProperties.getApiUrl}CurrenciesSetUp/GetCurrenciesSetUpListService`;
    this.http.post(this._URL, this.itemRequest, { withCredentials: true }).
      subscribe((res: any) => {
        this.currencyData = res.responseData;

        var object = {
          code: "Date",

        }
        this.currencyData.unshift(object);
        this.currencyData.forEach((element, index) => {
          if (element.code == "##" || element.code == "INR") {
            this.currencyData.splice(index, 1);
          }
        });
        this.displayedColumns = this.currencyData.map(col => col.code);
      });
  }


  onSave() {
    this.forkObj = new Object();
    this.lstData.forEach((ele: any, index) => {
      this.compareData(ele, this.originalData[index]);
    })
    forkJoin(this.forkObj).subscribe({
      next: response => this.isPressed = false,
      error: error => console.error('One or more API calls failed:', error)
    })
    this.originalData = JSON.parse(JSON.stringify(this.lstData));
  }


  // Function to compare data
  compareData(currentObj: any, originalObj: any) {
    for (let key in currentObj) {
      if (key !== "Date") {
        if (currentObj[key] != originalObj[key] || !originalObj[key]) {
          if (Number(currentObj[key]) > 0) {
            var request = {
              "RateDate": currentObj.Date.split("-").reverse().join("-"),
              "Rate": Number(currentObj[key]),
              "Currency": key
            };
            this.forkObj[`${currentObj.Date}${key}`] = this.http.patch(`${GlobalProperties.getApiUrlSap}SBOBobService_SetCurrencyRate`, request, { withCredentials: true })
          }
        }
      }
    }
  }

  // Call the function

}


